export function FormInput({
  name,
  label = name,
  register,
  errors = {},
  placeholder = "",
  type = "text",
  required = false,
}) {
  return (
    <div className="d-flex flex-col mb-s max-w-300 w-100 mx-auto">
      <label
        htmlFor={name}
        className={`h4 mb-xs mx-xs ${errors[name] ? "text-error" : ""}`}
      >
        {label} {required && <span className="error">*</span>}
      </label>
      <input
        type={type}
        name={name}
        id={name}
        placeholder={placeholder}
        {...register(name, { required })}
        className={`border-radius-s  px-xs py-xs max-w-400 mx-xs ${
          errors[name] ? "border-error" : "border-black-10"
        }`}
      />
      {required && errors[name] && (
        <p className="text-error text-small mx-xs">{label} is verplicht</p>
      )}
    </div>
  );
}
